import React from 'react'

const dico = {
  languageCode: {
    fr: 'fr',
    en: 'en',
    de: 'de',
  },
  Cart: {
    fr: 'Panier',
    en: 'Cart',
    de: 'Warenkorb',
  },
  'Add to cart': {
    fr: 'Ajouter au Panier',
    en: 'Add to cart',
    de: 'In den Warenkorb legen',
  },
  'Reset my current cart and add composition': {
    fr: 'Vider mon panier et ajouter',
    en: 'Reset my cart and add',
    de: 'Aktuellen Warenkorb leeren und Komposition hinzufügen',
  },
  'Add my composition to current cart': {
    fr: 'Ajouter au Panier',
    en: 'Add to cart',
    de: 'Meine Komposition zum aktuellen Warenkorb hinzufügen',
  },
  'TOTAL HT': {
    fr: 'TOTAL HT',
    en: 'TOTAL without taxes',
    de: 'GESAMT ohne Steuern',
  },
  'TOTAL TTC': {
    fr: 'TOTAL TTC',
    en: 'TOTAL with taxes',
    de: 'GESAMT mit Steuern',
  },
  Details: {
    fr: 'Panier',
    en: 'Cart',
    de: 'Warencorb',
  },
  Title: {
    fr: 'Titre',
    en: 'Title',
    de: 'Titel',
  },
  Reset: {
    fr: 'Recommencer',
    en: 'Reset',
    de: 'Zurücksetzen',
  },
  Image: {
    fr: 'Image',
    en: 'Image',
    de: 'Bild',
  },
  'Download image': {
    fr: 'Enregistrer une image',
    en: 'Download image',
    de: 'Bild herunterladen',
  },
  'Save composition': {
    fr: 'Enregistrer ma composition',
    en: 'Save my composition',
    de: 'Meine Komposition speichern',
  },
  'Open composition': {
    fr: 'Ouvrir une composition',
    en: 'Open my composition',
    de: 'Meine Komposition öffnen',
  },
  Save: {
    fr: 'Enregistrer',
    en: 'Save',
    de: 'Speichern',
  },
  Open: {
    fr: 'Ouvrir',
    en: 'Open',
    de: 'Öffnen',
  },
  'Wall bases': {
    fr: 'Bases murales',
    en: 'Wall bases',
    de: 'Wandbasen',
  },
  Boards: {
    fr: 'Planches',
    en: 'Boards',
    de: 'Bretter',
  },
  'Wall bases Color': {
    fr: 'Couleur Bases murales',
    en: 'Wall bases Color',
    de: 'Farbe der Wandbasen',
  },
  'wall bases colors': {
    fr: 'Bases murales : 3 couleurs',
    en: 'Wall bases: 3 colors',
    de: 'Wandbasen: 3 Farben',
  },
  'Boards Finishes': {
    fr: 'Finition Planches',
    en: 'Boards Finishes',
    de: 'Bretter Oberflächen',
  },
  'boards finishes': {
    fr: 'Planches : 4 finitions',
    en: 'Boards: 4 finishes',
    de: 'Bretter: 4 Oberflächen',
  },
  Accessories: {
    fr: 'Accessoires',
    en: 'Accessories',
    de: 'Zubehör',
  },
  Style: {
    fr: 'Finitions',
    en: 'Style',
    de: 'Stil',
  },
  'Order validation': {
    fr: 'Récapitulatif',
    en: 'Order validation',
    de: 'Bestellüberprüfung',
  },
  'GASSIEN Paris - my composition.png': {
    fr: 'GASSIEN Paris - ma composition.png',
    en: 'GASSIEN Paris - my composition.png',
    de: 'GASSIEN Paris - meine Komposition.png',
  },
  GF: {
    fr: 'L.80 x H.77cm',
    en: 'W.80 x H.77cm',
    de: 'B.80 x H.77cm',
  },
  MF: {
    fr: 'L.60 x H.77cm',
    en: 'W.60 x H.77cm',
    de: 'B.60 x H.77cm',
  },
  PF: {
    fr: 'L.40 x H.77cm',
    en: 'W.40 x H.77cm',
    de: 'B.40 x H.77cm',
  },
  GS: {
    fr: 'L.80 x H.44cm',
    en: 'W.80 x H.44cm',
    de: 'B.80 x H.44cm',
  },
  MS: {
    fr: 'L.60 x H.44cm',
    en: 'W.60 x H.44cm',
    de: 'B.60 x H.44cm',
  },
  GF_small: {
    fr: '80x77cm',
    en: '80x77cm',
    de: '80x77cm',
  },
  MF_small: {
    fr: '60x77cm',
    en: '60x77cm',
    de: '60x77cm',
  },
  PF_small: {
    fr: '40x77cm',
    en: '40x77cm',
    de: '40x77cm',
  },
  GS_small: {
    fr: '80x44cm',
    en: '80x44cm',
    de: '80x44cm',
  },
  MS_small: {
    fr: '60x44cm',
    en: '60x44cm',
    de: '60x44cm',
  },
  Calculate: {
    fr: 'Calculer les bases nécessaires',
    en: 'Define number of wall bases',
    de: 'Anzahl der Wandbasen bestimmen',
  },
  Advices: {
    fr: 'Conseils',
    en: 'Advices',
    de: 'Ratschläge',
  },
  'Space dimensions': {
    fr: 'Modéliser mon espace',
    en: 'Space dimensions',
    de: 'Raumdimensionen',
  },
  Desk: {
    fr: 'Bureau',
    en: 'Desk',
    de: 'Schreibtisch',
  },
  'Pot holder ⌀11cm': {
    fr: 'Porte pot ⌀11cm',
    en: 'Pot holder ⌀11cm',
    de: 'Topfhalter ⌀11cm',
  },
  'Pot holder ⌀15cm': {
    fr: 'Porte pot ⌀15cm',
    en: 'Pot holder ⌀15cm',
    de: 'Topfhalter ⌀15cm',
  },
  'Pot holder': {
    fr: 'Porte pot',
    en: 'Pot holder',
    de: 'Topfhalter',
  },
  'Towel rack': {
    fr: 'Porte Serviette',
    en: 'Towel rack',
    de: 'Handtuchhalter',
  },
  'Towel rack 40cm': {
    fr: 'Porte Serviette L.40cm',
    en: 'Towel rack W.40cm',
    de: 'Handtuchhalter B.40cm',
  },
  'Towel rack 60cm': {
    fr: 'Porte Serviette L.60cm',
    en: 'Towel rack W.60cm',
    de: 'Handtuchhalter B.60cm',
  },
  'Vase holder': {
    fr: 'Porte vase',
    en: 'Vase holder',
    de: 'Vasenhalter',
  },
  'Vase holder 10cm': {
    fr: 'Porte vase 10cm',
    en: 'Vase holder ⌀11cm',
    de: 'Vasenhalter ⌀11cm',
  },
  vaseHolder_10: {
    fr: 'Porte vase 10cm',
    en: 'Vase holder ⌀11cm',
    de: 'Vasenhalter ⌀11cm',
  },
  'Vase holder 15cm': {
    fr: 'Porte vase 15cm',
    en: 'Vase holder 15cm',
    de: 'Vasenhalter 15cm',
  },
  vaseHolder_15: {
    fr: 'Porte vase 15cm',
    en: 'Vase holder 15cm',
    de: 'Vasenhalter 15cm',
  },
  'Frame holder': {
    fr: 'Porte cadre',
    en: 'Frame holder',
    de: 'Rahmenhalter',
  },
  'Frame holder 40cm': {
    fr: 'Porte cadre 40cm',
    en: 'Frame holder 40cm',
    de: 'Rahmenhalter 40cm',
  },
  frameHolder_40: {
    fr: 'Porte cadre 40cm',
    en: 'Frame holder 40cm',
    de: 'Rahmenhalter 40cm',
  },
  'Computer holder': {
    fr: 'Porte ordinateur',
    en: 'Computer holder',
    de: 'Computerhalter',
  },
  computerHolder: {
    fr: 'Porte ordinateur',
    en: 'Computer holder',
    de: 'Computerhalter',
  },
  'Hanger holder': {
    fr: 'Porte cintre p.30cm',
    en: 'Hanger holder d.30cm',
    de: 'Kleiderbügelhalter d.30cm',
  },
  hangerHolder: {
    fr: 'Porte cintre p.30cm',
    en: 'Hanger holder d.30cm',
    de: 'Kleiderbügelhalter d.30cm',
  },
  glassesRacks: {
    fr: 'Racks à verres',
    en: 'Glasses racks',
    de: 'Gläserregale',
  },
  'Set of 3 glasses racks': {
    fr: 'Lot de 3 racks à verres',
    en: 'Set of 3 glasses racks',
    de: 'Set von 3 Gläserregalen',
  },
  glassesHolder_with_glasses: {
    fr: 'Lot de 3 racks à verres',
    en: 'Set of 3 glasses racks',
    de: 'Set von 3 Gläserregalen',
  },
  Others: {
    fr: 'Autres',
    en: 'Others',
    de: 'Andere',
  },
  Hooks: {
    fr: 'Crochets',
    en: 'Hooks',
    de: 'Haken',
  },
  'Hooks (x3)': {
    fr: 'Crochets (x3)',
    en: 'Hooks (x3)',
    de: 'Haken (x3)',
  },
  '': {
    fr: '',
    en: '',
    de: '',
  },
  black: {
    fr: 'noir',
    en: 'black',
    de: 'schwarz',
  },
  white: {
    fr: 'blanc',
    en: 'white',
    de: 'weiß',
  },
  brass: {
    fr: 'laiton',
    en: 'brass',
    de: 'Messing',
  },
  birch: {
    fr: 'bouleau',
    en: 'birch',
    de: 'Birke',
  },
  oak: {
    fr: 'chêne massif',
    en: 'oak',
    de: 'Eiche',
  },
  'My composition': {
    fr: 'Ma composition',
    en: 'My composition',
    de: 'Meine Komposition',
  },
  Configuration: {
    fr: 'Configuration',
    en: 'Configuration',
    de: 'Konfiguration',
  },
  'Small Support brackets': {
    fr: 'Petites accroches',
    en: 'Small Support brackets',
    de: 'Kleine Stützklammern',
  },
  'Big Support brackets': {
    fr: 'Grandes accroches',
    en: 'Big Support brackets',
    de: 'Große Stützklammern',
  },
  Width: {
    fr: 'Longueur',
    en: 'Width',
    de: 'Breite',
  },
  Height: {
    fr: 'Hauteur',
    en: 'Height',
    de: 'Höhe',
  },
  Name: {
    fr: 'Nom',
    en: 'Name',
    de: 'Name',
  },
  'Big format': {
    fr: 'Grand format',
    en: 'Big format',
    de: 'Großformat',
  },
  'Medium format': {
    fr: 'Moyen format',
    en: 'Medium format',
    de: 'Mittelformat',
  },
  'Small format': {
    fr: 'Petit format',
    en: 'Small format',
    de: 'Kleinformat',
  },
  'Create an item': {
    fr: 'Créer un élément (délimiter un mur, placer un obstacle...)',
    en: 'Create an item (wall, obstacle)',
    de: 'Ein Element erstellen (Wand, Hindernis)',
  },
  Cancel: {
    fr: 'Annuler',
    en: 'Cancel',
    de: 'Abbrechen',
  },
  'Number of Wall bases': {
    fr: 'Nombre de bases murales',
    en: 'Number of Wall bases',
    de: 'Anzahl der Wandbasen',
  },
  'You can combine in width:': {
    fr: 'Vous pouvez associer en largeur :',
    en: 'You can combine in width:',
    de: 'Sie können in der Breite kombinieren:',
  },
  'You can combine in height:': {
    fr: 'Vous pouvez associer en hauteur :',
    en: 'You can combine in haight:',
    de: 'Sie können in der Höhe kombinieren:',
  },
  Grid: {
    fr: 'Grille',
    en: 'Grid',
    de: 'Gitter',
  },
  or: {
    fr: 'ou',
    en: 'or',
    de: 'oder',
  },
  'Number in width:': {
    fr: 'Nombre en largeur :',
    en: 'Number in width:',
    de: 'Anzahl in der Breite:',
  },
  'Number in height:': {
    fr: 'Nombre en hauteur :',
    en: 'Number in height:',
    de: 'Anzahl in der Höhe:',
  },
  Quantities: {
    fr: 'Quantités',
    en: 'Quantities',
    de: 'Mengen',
  },
  Qty: {
    fr: 'Qté',
    en: 'Qty',
    de: 'Menge',
  },
  'Price (incl. taxes)': {
    fr: 'Prix (TTC)',
    en: 'Price (incl. taxes)',
    de: 'Preis (inkl. Steuern)',
  },
  Total: {
    fr: 'Total',
    en: 'Total',
    de: 'Gesamt',
  },
  Length: {
    fr: 'Longueur',
    en: 'Length',
    de: 'Länge',
  },
  'Show dimensions': {
    fr: 'Afficher les dimensions',
    en: 'Show dimensions',
    de: 'Maße anzeigen',
  },
  'Pot sold separetly': {
    fr: 'Pots vendus séparément',
    en: 'Pot sold separately',
    de: 'Topf separat verkauft',
  },
  Configurator: {
    fr: 'Configurateur',
    en: 'Configurator',
    de: 'Konfigurator',
  },
  content_style: {
    fr: (
      <p>
        Choisissez le style de votre composition en sélectionant :
        <br />
        - une couleur pour vos bases murales
        <br />
        - une finition de bois pour vos planches
      </p>
    ),
    en: (
      <p>
        Choose the style of your arrangement by selecting:
        <br />
        - color for your wall bases
        <br />
        - wood finshes for your boards
      </p>
    ),
    de: (
      <p>
        Wählen Sie den Stil Ihrer Komposition, indem Sie auswählen:
        <br />
        - eine Farbe für Ihre Wandbasen
        <br />
        - ein Holzfinish für Ihre Bretter
      </p>
    ),
  },
  content_wall_bases: {
    fr: (
      <p>
        Sélectionnez vos bases murales en fonction de la taille de votre espace
        (2 dimensions : L.60 x 77cm ou L.80 x 77cm).
        <br />
        Vous pouvez juxtaposer les bases murales en hauteur, en longueur ou en décalé.
      </p>
    ),
    en: (
      <p>
        Select your wall bases, regarding dimensions of your space (2 sizes).
        <br />
        You can combine several wall bases mounted in the width,
        in the height, and even staggered.
      </p>
    ),
    de: (
      <p>
        Wählen Sie Ihre Wandbasen entsprechend den Abmessungen Ihres Raumes
        (2 Größen: L.60 x 77cm oder L.80 x 77cm).
        <br />
        Sie können die Wandbasen in der Höhe, in der Breite und sogar versetzt aneinanderreihen.
      </p>
    ),
  },
  content_boards: {
    fr: (
      <p>
        Sélectionnez et placez vos planches ou le bureau sur les bases murales.
        <br />
        8 dimensions de planches et 2 bureaux.
      </p>
    ),
    en: (
      <p>
        Select your boards and your desk among our 10 different sizes.
      </p>
    ),
    de: (
      <p>
        Wählen und platzieren Sie Ihre Bretter oder den Schreibtisch auf den Wandbasen.
        <br />
        8 Brettergrößen und 2 Schreibtischgrößen.
      </p>
    ),
  },
  content_accessories: {
    fr: (
      <p>
        Vous pouvez ajouter des accessoires à votre composition :
        <br />
        - porte-pots (⌀11cm),
        <br />
        - porte serviettes (L.40 cm ou L. 60cm),
        <br />
        - crochets (vendus par 3)
        <br />
      </p>
    ),
    en: (
      <p>
        You can add some accessories to your composition:
        <br />
        - pot holder (⌀11cm),
        <br />
        - towel racks (W.40 cm or W. 60cm),
        <br />
        - hooks
      </p>
    ),
    de: (
      <p>
        Sie können Ihrer Komposition Zubehör hinzufügen:
        <br />
        - Topfhalter (⌀11cm),
        <br />
        - Handtuchstangen (B.40 cm oder B. 60cm),
        <br />
        - Haken (im 3er-Set verkauft)
      </p>
    ),

  },
  gridGF: {
    fr: 'Base murale 80x77cm',
    en: 'Wall base 80x77cm',
    de: 'Wandbasis 80x77cm',
  },
  gridMF: {
    fr: 'Base murale 60x77cm',
    en: 'Wall base 60x77cm',
    de: 'Wandbasis 60x77cm',
  },
  gridPF: {
    fr: 'Base murale 40x77cm',
    en: 'Wall base 40x77cm',
    de: 'Wandbasis 40x77cm',
  },
  gridGS: {
    fr: 'Base murale 80x44cm',
    en: 'Wall base 80x44cm',
    de: 'Wandbasis 80x44cm',
  },
  gridMS: {
    fr: 'Base murale 60x44cm',
    en: 'Wall base 60x44cm',
    de: 'Wandbasis 60x44cm',
  },
  board40x15: {
    fr: 'Planche 40x15cm',
    en: 'Board 40x15cm',
    de: 'Brett 40x15cm',
  },
  board60x15: {
    fr: 'Planche 60x15cm',
    en: 'Board 60x15cm',
    de: 'Brett 60x15cm',
  },
  board80x15: {
    fr: 'Planche 80x15cm',
    en: 'Board 80x15cm',
    de: 'Brett 80x15cm',
  },
  board40x20: {
    fr: 'Planche 40x20cm',
    en: 'Board 40x20cm',
    de: 'Brett 40x20cm',
  },
  board60x20: {
    fr: 'Planche 60x20cm',
    en: 'Board 60x20cm',
    de: 'Brett 60x20cm',
  },
  board80x20: {
    fr: 'Planche 80x20cm',
    en: 'Board 80x20cm',
    de: 'Brett 80x20cm',
  },
  board60x30_t2: {
    fr: 'Planche 60x30cm',
    en: 'Board 60x30cm',
    de: 'Brett 60x30cm',
  },
  board60x30_t3: {
    fr: 'Planche 60x30cm',
    en: 'Board 60x30cm',
    de: 'Brett 60x30cm',
  },
  board60x30_t2_left: {
    fr: 'Planche 60x30cm',
    en: 'Board 60x30cm',
    de: 'Brett 60x30cm links',
  },
  board60x30_t2_right: {
    fr: 'Planche 60x30cm',
    en: 'Board 60x30cm',
    de: 'Brett 60x30cm rechts',
  },
  board80x30_t2: {
    fr: 'Planche 80x30cm',
    en: 'Board 80x30cm',
    de: 'Brett 80x30cm',
  },
  board80x30_t2_left: {
    fr: 'Planche 80x30cm',
    en: 'Board 80x30cm',
    de: 'Brett 80x30cm links',
  },
  board80x30_t2_right: {
    fr: 'Planche 80x30cm',
    en: 'Board 80x30cm',
    de: 'Brett 80x30cm rechts',
  },
  board80x30_t3: {
    fr: 'Planche 80x30cm',
    en: 'Board 80x30cm',
    de: 'Brett 80x30cm',
  },
  desk80x50: {
    fr: 'Bureau 80x50cm',
    en: 'Desk 80x50cm',
    de: 'Schreibtisch 80x50cm',
  },
  desk60x50: {
    fr: 'Bureau 60x50cm',
    en: 'Desk 60x50cm',
    de: 'Schreibtisch 60x50cm',
  },
  potHolder_11: {
    fr: 'Porte pot ⌀11cm',
    en: 'Pot holder ⌀11cm',
    de: 'Topfhalter ⌀11cm',
  },
  potHolder_11_with_pot: {
    fr: 'Porte pot ⌀11cm',
    en: 'Pot holder ⌀11cm',
    de: 'Topfhalter ⌀11cm mit Topf',
  },
  potHolder_15: {
    fr: 'Porte pot ⌀15cm',
    en: 'Pot holder ⌀15cm',
    de: 'Topfhalter ⌀15cm',
  },
  hooks: {
    fr: 'Crochets (x3)',
    en: 'Hooks (x3)',
    de: 'Haken (x3)',
  },
  ps40: {
    fr: 'Porte serviette 40cm',
    en: 'Towel rack 40cm',
    de: 'Handtuchhalter 40cm',
  },
  ps60: {
    fr: 'Porte serviette 60cm',
    en: 'Towel rack 60cm',
    de: 'Handtuchhalter 60cm',
  },
  Wardrobe: {
    fr: 'Penderie',
    en: 'Wardrobe',
    de: 'Kleiderschrank',
  },
  Help: {
    fr: 'Aide',
    en: 'Help',
    de: 'Hilfe',
  },
  Tips: {
    fr: 'Astuces',
    en: 'Tips',
    de: 'Tipps',
  },
  Finishes: {
    fr: 'Finitions',
    en: 'Finishes',
    de: 'Oberflächen',
  },
  Order: {
    fr: 'Commande',
    en: 'Order',
    de: 'Bestellung',
  },
  'Start your composition': {
    fr: 'Commencez votre configuration',
    en: 'Start your arrangement',
    de: 'Beginne deine Komposition',
  },
  'Contact us': {
    fr: 'Contactez-nous',
    en: 'Contact us',
    de: 'Kontaktiere uns',
  },
  'With our configurator you can design your own arrangement.': {
    fr: 'Notre configurateur vous permet de modéliser votre propre composition.',
    en: 'With our configurator you can design your own arrangement.',
    de: 'Mit unserem Konfigurator kannst du deine eigene Anordnung entwerfen.',
  },
  'Select colors and finishes you want (you can change anytime during the configuration process).': {
    fr: 'Choisissez les couleurs et finitions souhaitées (que vous pouvez modifier à tout moment de la configuration).',
    en: 'Select colors and finishes you want (you can change anytime during the configuration process).',
    de: 'Wähle die Farben und Oberflächen, die du möchtest (Du kannst sie jederzeit während des Konfigurationsprozesses ändern).',
  },
  'Start by disposing the wall bases you need (5 sizes), click on the button to make them appear and drag them as you want.': {
    fr: 'Commencez par placer vos bases murales (5 tailles), en cliquant sur les cartouches pour les faire apparaître, et positionnez-les en les faisant glisser comme vous le souhaitez.',
    en: 'Start by disposing the wall bases you need (5 sizes), click on the button to make them appear and drag them as you want.',
    de: 'Beginne mit der Auswahl der benötigten Wandbasen (5 Größen), klicke auf den Knopf, um sie erscheinen zu lassen, und ziehe sie nach Belieben.',
  },
  'Select your boards among 8 sizes and 2 desks. Drag them on your wall bases to compose your shelve.': {
    fr: 'Vous pouvez sélectionner vos planches parmi 8 dimensions et 2 bureaux. Déplacez-les ensuite sur vos bases murales afin de composer votre propre étagère.',
    en: 'Select your boards among 8 sizes and 2 desks. Drag them on your wall bases to compose your shelve.',
    de: 'Wähle deine Bretter aus 8 Größen und 2 Schreibtischen. Ziehe sie auf deine Wandbasen, um dein Regal zu komponieren.',
  },
  'You can add some accessories to your composition:': {
    fr: 'Vous pouvez compléter par des accessoires :',
    en: 'You can add some accessories to your composition:',
    de: 'Du kannst deiner Komposition einige Zubehörteile hinzufügen:',
  },
  'pot holder (⌀11cm or ⌀15cm) (Pot sold separately),': {
    fr: 'porte-pot (⌀11cm ou ⌀15cm) (pot vendu séparément),',
    en: 'pot holder (⌀11cm or ⌀15cm) (Pot sold separately),',
    de: 'Topfhalter (⌀11cm oder ⌀15cm) (Topf separat verkauft),',
  },
  'towel rack (W.40cm or W.60cm,': {
    fr: 'porte-serviette (L.40 cm ou L.60cm),',
    en: 'towel rack (W.40cm or W.60cm),',
    de: 'Handtuchhalter (B.40cm oder B.60cm),',
  },
  'hooks (by 3)': {
    fr: 'crochets (vendus par 3)',
    en: 'hooks (by 3)',
    de: 'Haken (im 3er-Set)',
  },
  'accessories-en': {
    fr: 'accessoires-fr',
    en: 'accessories-en',
    de: 'Zubehör-de',
  },

  'Define your space and principal items (radiator, window, sofa…) with [Space dimensions].': {
    fr: (
      <>
        Délimitez votre espace et modélisez certains éléments de cet espace
        (radiateur, fenêtre, canapé…) à l’aide du bouton
        {' '}
        <b>[Modéliser mon espace]</b>
        .
      </>
    ),
    en: (
      <>
        Define your space and principal items (radiator, window, sofa…) with
        {' '}
        <b>[Space dimensions]</b>
        .
      </>
    ),
    de: (
      <>
        Definiere deinen Raum und die wichtigsten Elemente (Heizkörper, Fenster, Sofa…) mit
        {' '}
        <b>[Raumabmessungen]</b>
        .
      </>
    ),
  },
  'Your arrangement\'s price adjusts as the configuration progresses.': {
    fr: 'Le prix de votre composition s’ajuste au fur et à mesure de votre configuration et en fonction de vos finitions.',
    en: 'Your arrangement\'s price adjusts as the configuration progresses.',
    de: 'Der Preis Ihrer Anordnung passt sich mit dem Fortschreiten der Konfiguration an.',
  },
  '<b>[Details]</b> presents the configuration items list you can add to your cart.': {
    fr: (
      <>
        <b>[Détails]</b>
        {' '}
        présente la liste des éléments de la configuration
        que vous pouvez ajouter au panier en un clic.
      </>
    ),
    en: (
      <>
        <b>[Details]</b>
        {' '}
        presents the configuration items list you can add to your cart.
      </>
    ),
    de: (
      <>
        <b>[Details]</b>
        {' '}
        präsentiert die Liste der Konfigurationselemente, die du deinem Warenkorb hinzufügen kannst.
      </>
    ),
  },
  'contact us Tuto message': {
    fr: (
      <>
        N&apos;hésitez pas à nous&nbsp;
        <a href="mailto:contact@gassien.com?subject=Informations Gassien" style={{ textDecoration: 'underline' }}>contacter</a>
        &nbsp;si vous souhaitez de l&apos;aide ou avez des demandes spécifiques.
      </>
    ),
    en: (
      <>
        Don&apos;t hesitate to &nbsp;
        <a href="mailto:contact@gassien.com?subject=Informations Gassien" style={{ textDecoration: 'underline' }}>contact us</a>
        &nbsp;if you need more informations or specific requests.
      </>
    ),
    de: (
      <>
        Du kannst uns jederzeit
        {' '}
        <a href="mailto:contact@gassien.com?subject=Informations Gassien" style={{ textDecoration: 'underline' }}>kontaktieren</a>
        , falls du Hilfe benötigst oder spezielle Anfragen hast.
      </>
    ),
  },
  'Please enter your composition number': {
    fr: 'Veuillez saisir les 6 chiffres de votre composition',
    en: 'Please enter your composition number',
    de: 'Bitte geben Sie Ihre Kompositionsnummer ein',
  },
  'Your composition number is:': {
    fr: 'Votre numéro de composition est le :',
    en: 'Your composition number is:',
    de: 'Ihre Kompositionsnummer lautet:',
  },
  Copy: {
    fr: 'Copier',
    en: 'Copy',
    de: 'Kopieren',
  },
  'Copy Link': {
    fr: 'Copier le Lien',
    en: 'Copy Link',
    de: 'Link kopieren',
  },
  'You can keep it to retrieve at any time your composition': {
    fr: 'Vous pouvez le conserver pour retrouver à tous moments votre composition',
    en: 'You can keep it to retrieve at any time your composition',
    de: 'Sie können es behalten, um Ihre Komposition jederzeit abzurufen',
  },
  'You can contact us (contact@gassien.com) with this id for specific needs': {
    fr: 'Contactez-nous avec cet numéro pour toutes demandes spécifiques',
    en: 'Contact us with this id for specific needs',
    de: 'Kontaktieren Sie uns (contact@gassien.com) mit dieser ID für spezielle Anforderungen',
  },
  'This composition doesn\'t exist': {
    fr: 'Cette composition n\'existe pas',
    en: 'This composition doesn\'t exist',
    de: 'Diese Komposition existiert nicht',
  },
  'Impossible to save compossition': {
    fr: 'Impossible d\'enregistrer la composition',
    en: 'Impossible to save compossition',
    de: 'Komposition kann nicht gespeichert werden',
  },
  Share: {
    fr: 'Partager',
    en: 'Share',
    de: 'Teilen',
  },
  'My Gassien Composition': {
    fr: 'Ma composition Gassien',
    en: 'My Gassien Composition',
    de: 'Meine Gassien-Komposition',
  },
  'Have a look to my Gassien composition:': {
    fr: 'Voici ma composition Gassien :',
    en: 'Have a look to my Gassien composition:',
    de: 'Schauen Sie sich meine Gassien-Komposition an:',
  },
  'Height 77cm': {
    fr: 'Hauteur 77cm',
    en: 'Height 77cm',
    de: 'Höhe 77cm',
  },
  'Height 44cm': {
    fr: 'Hauteur 44cm',
    en: 'Height 44cm',
    de: 'Höhe 44cm',
  },
}


export default dico
